import { ModalController } from '@ionic/angular';
import { StoreService } from './../../../services/store.service';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { CommonService } from 'src/app/services/common.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pick-country',
  templateUrl: './pick-country.component.html',
  styleUrls: ['./pick-country.component.scss'],
})
export class PickCountryComponent implements OnInit {
  countries: any[];
  constructor(
    private common: CommonService,
    private helper: CommonMessageService,
    private store: StoreService,
    private modalController: ModalController,
  ) { }

  ngOnInit() {
    this.getPays();
  }
  dismiss(data?) {
    this.modalController.dismiss(data);
  }
  async getPays() {
    if (this.store.tmp.countries) {
      return this.countries = this.store.tmp.countries;
    }
    const loading = await this.helper.loading('Patientez un instant');
    try {
      const allConst = (await this.common.pays().toPromise()) as any;
      this.countries = allConst.filter(e => e.codePays === 'ml' || e.codePays === 'sn' || e.codePays === 'ci' ||
        e.codePays === 'bf' || e.codePays === 'ne' || e.codePays === 'bj' || e.codePays === 'tg' || e.codePays === 'gn'
        || e.codePays === 'fr' || e.codePays === 'ma' || e.codePays === 'dz' || e.codePays === 'tn' || e.codePays === 'us'
        || e.codePays === 'ca');
      this.countries.push(...allConst);
      this.store.tmp.countries = this.countries;
      // this.countries.forEach(c => c.codePays = (c.paysFr + '').toLowerCase().substr(0, 2));
    } catch (error) {
      this.helper.errorToast('Erreur: ' + error);
    } finally {
      loading.dismiss();
    }
  }
}
